"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getQuestionFieldCommentId = exports.getQuestionFieldId = exports.getQuestionElement = void 0;
const adaptivecards_1 = require("adaptivecards");
const SurveyLimits_1 = require("../../survey/utils/SurveyLimits");
const CardHelper_1 = require("../utils/CardHelper");
function getQuestionElement(question, defaultValue, defaultCommentValue) {
    let element;
    switch (question.questionType) {
        case "open-ended":
            element = getOpenEnded(question, defaultValue);
            break;
        case "nominal":
            element = getNominal(question, defaultValue);
            break;
        case "ordinal":
            element = getOrdinal(question, defaultValue);
            break;
        default:
            throw new Error(`unsupported question type ${question.questionType} on ${question.id}`);
    }
    if (!question.allowComments) {
        return element;
    }
    const container = CardHelper_1.CardHelper.create(adaptivecards_1.Container);
    container.addItem(element);
    container.addItem(CardHelper_1.CardHelper.create(adaptivecards_1.TextInput, {
        id: getQuestionFieldCommentId(question.id),
        placeholder: question.commentAppeal || "Additional comments (optional)",
        isMultiline: false,
        defaultValue: defaultCommentValue,
    }));
    return container;
}
exports.getQuestionElement = getQuestionElement;
function getOpenEnded(question, defaultValue) {
    switch (question.contentType) {
        case "text/plain":
            return CardHelper_1.CardHelper.create(adaptivecards_1.TextInput, {
                id: getQuestionFieldId(question.id),
                placeholder: "Enter a response",
                spacing: adaptivecards_1.Spacing.Medium,
                defaultValue,
                isMultiline: true,
                maxLength: SurveyLimits_1.SurveyLimits.Questions.OpenEnded.Value.MaxLength,
            });
        case "text/date":
            return CardHelper_1.CardHelper.create(adaptivecards_1.DateInput, {
                id: getQuestionFieldId(question.id),
                defaultValue,
            });
        case "text/time":
            return CardHelper_1.CardHelper.create(adaptivecards_1.TimeInput, {
                id: getQuestionFieldId(question.id),
                defaultValue,
            });
        default:
            throw Error(`Unknown question ${question.id} content type ${question.contentType}`);
    }
}
function getNominal(question, defaultValue) {
    return getChoiceSelectionInput(question.id, question.choices.map(c => new adaptivecards_1.Choice(c.value, c.id)), defaultValue, question.allowMultipleChoices);
}
function getOrdinal(question, defaultValue) {
    return getChoiceSelectionInput(question.id, question.choices.map(c => new adaptivecards_1.Choice(c.label, c.id)), defaultValue, question.allowMultipleChoices);
}
function getChoiceSelectionInput(questionId, choices, defaultValue, isMultiSelect) {
    const isRadio = isMultiSelect || !(choices.some(c => c.title.length > 50) || choices.length > 5);
    const choiceSet = CardHelper_1.CardHelper.create(adaptivecards_1.ChoiceSetInput, {
        id: getQuestionFieldId(questionId),
        placeholder: "Select a choice",
        wrap: true,
        isCompact: !isRadio,
        isMultiSelect,
        defaultValue,
        choices,
    });
    return choiceSet;
}
function getQuestionFieldId(id) {
    return `q_${id}`;
}
exports.getQuestionFieldId = getQuestionFieldId;
function getQuestionFieldCommentId(id) {
    return `${getQuestionFieldId(id)}_comment`;
}
exports.getQuestionFieldCommentId = getQuestionFieldCommentId;
//# sourceMappingURL=QuestionInputElement.js.map